import React from 'react';
import './SideNavbar.css';

function SideNavbar() {
  return (
    <nav className="side-navbar">
      <div className="nav__logo">
            <a href="index.html" className="nav__logo-text">PK</a>
      </div>
      <ul>
        <li>Home</li>
        <li>About</li>
        <li>Skills</li>
        <li>Projects</li>
      </ul>
    </nav>
  );
}

export default SideNavbar;
